import formatDateTranslates from 'helpers/format-date-i18n.json';
import numDescTranslates from 'helpers/num-desc-i18n.json';
// import reliabilityIndexTranslates from './reliability-index-i18n.json';
import developerTranslates from '../section-developer/developer-i18n';
import configLabelsTranslates from './config-labels-i18n';

export default function () {
  return {
    ...formatDateTranslates,
    ...numDescTranslates,
    // ...reliabilityIndexTranslates,
    ...developerTranslates(),
    ...configLabelsTranslates,

    more: {
      ru: 'Eщe',
      ua: 'Ще'
    },
    moreDetails: {
      ru: 'Подробнее',
      ua: 'Детальніше'
    },

    call: {
      ru: 'Позвонить',
      ua: 'Дзвонити'
    },

    year: {
      ru: 'год',
      ua: 'рік'
    },

    textLC: {
      ru: 'ЖК',
      ua: 'ЖК'
    },
    textCT: {
      ru: 'КП',
      ua: 'КМ'
    },

    overflight: {
      ru: 'Аэрооблёт',
      ua: 'Аерообліт'
    },

    // linkToBackText: {
    //   ru: 'К результатам поиска',
    //   ua: 'До результатив пошуку'
    // },

    tabMain: {
      ru: 'О комплексе',
      ua: 'Про комплекс'
    },

    btnToLocation: {
      ru: 'К размещению',
      ua: 'До розміщення'
    },

    linkToSiteText: {
      ru: 'Сайт{{placeholder}}',
      ua: 'Сайт{{placeholder}}'
    },
    blockComplaintText: {
      ru: 'Заметили неточность? Сообщите нам',
      ua: 'Помітили невідповідність? Повідомте нам'
    },
    btnComplaintText: {
      ru: 'Сообщить о неточности',
      ua: 'Повідомити про неточність'
    },
    askQuestionNotification: {
      ru: 'Спасибо, ваше сообщение отправлено.',
      ua: 'Дякуємо, ваше повідомлення надіслано.'
    },

    developerSale: {
      ru: 'Продажа от застройщика',
      ua: 'Продаж від забудовника'
    },
    askPrice: {
      ru: 'Спросить о ценах и наличии',
      ua: 'Запитати про ціни та наявність'
    },
    askClarifyDetails: {
      ru: 'Уточнить детали',
      ua: 'Уточнити деталі'
    },
    linkShowAllPlansText: {
      ru: 'Смотреть все планировки',
      ua: 'Переглянути усі планування'
    },
    dateLifeInfo: {
      ru: 'Цены на{{placeholder}} от застройщика актуальны на',
      ua: 'Ціни на{{placeholder}} від забудовника актуальні на'
    },

    purchaseOptionsTopic: {
      ru: 'Варианты покупки',
      ua: 'Варіанти придбання'
    },
    installment: {
      ru: 'Рассрочка',
      ua: 'Розстрочка'
    },
    credit: {
      ru: 'Кредит',
      ua: 'Кредит'
    },
    checkWithDeveloper: {
      ru: 'Уточнить детали',
      ua: 'Уточнити деталі'
    },
    wantDiscount: {
      ru: 'Хочу скидку!',
      ua: 'Хочу знижку!'
    },
    stock: {
      ru: 'Акция',
      ua: 'Акція'
    },

    mapTopic: {
      ru: 'Расположение',
      ua: 'Розташування'
    },
    mapBtnPanorama: {
      ru: 'Панорама',
      ua: 'Панорама'
    },
    textMinutes: {
      ru: 'мин.',
      ua: 'хв.'
    },

    complexYoutubeTopic: {
      ru: 'Видео о{{placeholder}}',
      ua: 'Відео про{{placeholder}}'
    },

    propertiesTopic: {
      ru: 'Характеристики{{placeholder}}',
      ua: 'Характеристики{{placeholder}}'
    },
    propertyReady: {
      ru: 'Срок сдачи{{placeholder}}',
      ua: 'Термін здачі{{placeholder}}'
    },
    propertyReadyYear: {
      ru: '{{placeholder}}\u00a0г.',
      ua: '{{placeholder}}\u00a0р.'
    },
    propertyYes: {
      ru: 'Да',
      ua: 'Так'
    },
    propertyThereIs: {
      ru: 'Есть',
      ua: 'Є'
    },
    propertyNo: {
      ru: 'Нет',
      ua: 'Немає'
    },

    constructionProgressTopic: {
      ru: 'Ход строительства',
      ua: 'Хід будівництва'
    },
    constructionProgressOnWebsiteLC: {
      ru: 'на сайте ЖК',
      ua: 'на сайті ЖК'
    },
    constructionProgressLinkText: {
      ru: 'Смотреть ход строительства',
      ua: 'Переглянути хід будівництва'
    },

    descriptionTopic: {
      ru: 'Описание',
      ua: 'Описання'
    },
    readMore: {
      ru: 'Читать еще',
      ua: 'Читати ще'
    },
    putIntoOperation: {
      ru: 'Сдан в эксплуатацию',
      ua: 'Зданий в експлуатацію'
    },
    newBuildingReliabilityIndex: {
      ru: 'Индекс надёжности новостройки',
      ua: 'Індекс надійності новобудови'
    },
    ofText: {
      ru: 'из',
      ua: 'з'
    },
    naText: {
      ru: 'н/а',
      ua: 'н/а'
    },
    checkLC: {
      ru: 'Проверить ЖК',
      ua: 'Перевірити ЖК'
    },

    publicationsTopic: {
      ru: 'С этим{{placeholder}} читают',
      ua: 'З цим{{placeholder}} читають'
    },

    nearestLivingComplexLCTopic: {
      ru: 'Новостройки рядом',
      ua: 'Новобудови поруч'
    },
    nearestLivingComplexCTTopic: {
      ru: 'Коттеджные посёлки рядом',
      ua: 'Котеджні містечка поблизу'
    },

    commentsTopic: {
      ru: 'А что вы думаете об{{placeholder}}?',
      ua: 'А що ви думаєте про{{placeholder}}?'
    },
    commentsAddToHeaderCTText: {
      ru: ' этом коттеджном посёлке',
      ua: ' це котеджне містечко'
    },
    commentsAddToHeaderLCText: {
      ru: ' этом комплексе',
      ua: ' цей комплекс'
    },

    rooms: {
      ru: 'Количество комнат',
      ua: 'Кількість кімнат'
    },
    type: {
      ru: 'Тип',
      ua: 'Тип'
    },
    commissioning: {
      ru: 'Ввод в эксплуатацию',
      ua: 'Введення в експлуатацію'
    },
    btnAllText: {
      ru: 'Все',
      ua: 'Всі'
    },
    btnAnyTimeText: {
      ru: 'Любое время',
      ua: 'Будь-який час'
    },

    floors: {
      ru: 'Этажи',
      ua: 'Поверхи'
    },
    areaAll: {
      ru: 'Общая площадь',
      ua: 'Загальна площа'
    },
    areaLiv: {
      ru: 'Жилая площадь',
      ua: 'Житлова площа'
    },
    areaKit: {
      ru: 'Площадь кухни',
      ua: 'Площа кухні'
    },
    areaLand: {
      ru: 'Площадь участка',
      ua: 'Площа ділянки'
    },
    bedroomsCount: {
      ru: 'Спален',
      ua: 'Спалень'
    },
    bathroomsCount: {
      ru: 'Санузлов',
      ua: 'Санвузлів'
    },
    linkToListObjects: {
      ru: 'К списку планировок',
      ua: 'До списку планувань'
    },

    tableDeadlineTopic1: {
      ru: 'Название элемента ЖК',
      ua: 'Назва елемента ЖК'
    },
    tableDeadlineTopic2: {
      ru: 'Обещанный квартал',
      ua: 'Обіцяний квартал'
    },
    tableDeadlineTopic3: {
      ru: 'Обещанный год',
      ua: 'Обіцяний рік'
    },
    tableDeadlineTopic4: {
      ru: 'Задержка сдачи',
      ua: 'Затримка здачі'
    },
    tableDeadlineTopic5: {
      ru: 'Сдали квартал',
      ua: 'Здали квартал'
    },
    tableDeadlineTopic6: {
      ru: 'Сдали год',
      ua: 'Здали рік'
    },
    tableDeadlineTopic7: {
      ru: 'Дата последней записи',
      ua: 'Дата останнього запису'
    },
    tableColDelayedDeliveryText: {
      ru: 'Задержка {{placeholderRU}}',
      ua: 'Затримка {{placeholderUA}}'
    },
    readyText: {
      ru: 'Сдан',
      ua: 'Здан'
    },
    readyOnTimeText: {
      ru: 'Сдан в срок',
      ua: 'Здан вчасно'
    },
    deadlineHasNotComeText: {
      ru: 'Срок сдачи не наступил',
      ua: 'Термін здачі не настав'
    },
    tableDeadlineAfterText: {
      ru: 'В таблице указаны сроки сдачи, которые были объявлены застройщиком первоначально.',
      ua: 'У таблиці вказані терміни здачі, які були оголошені забудовником спочатку.'
    },
    connectConsult: {
      ru: 'Отдел продаж',
      ua: 'Відділ продажу'
    },
    connectConsultShort: {
      ru: 'Консультант',
      ua: 'Консультант'
    },

    btnCardSoldHide: {
      ru: 'Скрыть проданные планировки',
      ua: 'Сховати продані планування'
    },
    btnCardSoldShow: {
      ru: 'Показать проданные планировки',
      ua: 'Показати продані планування'
    },
    objects: {
      ru: 'объекты',
      ua: 'об\'єкти'
    },

    scheduleWork: {
      ru: 'График работы',
      ua: 'Графік роботи'
    },
    /*
    scheduleStandard: {
      ru: 'Стандартный график',
      ua: 'Стандартний графік'
    },
    scheduleNonStandard: {
      ru: 'Нестандартный график',
      ua: 'Нестандартний графік'
    },
    scheduleNonStandard_2: {
      ru: 'Нестандартный график 2',
      ua: 'Нестандартний графік 2'
    },
    */
    scheduleNonStandardNote: {
      ru: 'Примечание к нестандартному графику',
      ua: 'Примітка до нестандартного графіка'
    },
    scheduleCanBeChanged: {
      ru: 'График работы может меняться. Перед визитом уточните в отделе продаж.',
      ua: 'Графік роботи може змінюватися. Перед візитом уточніть у відділі продажів.'
    },
    dayOff: {
      ru: 'Выходные',
      ua: 'Вихідні'
    },
    getRoute: {
      ru: 'Проложить маршрут',
      ua: 'Прокласти маршрут'
    },

    awardsH2: {
      ru: 'Награды Застройщика',
      ua: 'Нагороди Забудовника'
    },

    drivingDirectionsH2: {
      ru: 'Схема проезда',
      ua: 'Схема проїзду'
    },
    driveway: {
      ru: 'Проезд {{placeholder}}',
      ua: 'Проїзд {{placeholder}}'
    }
  };
}
